import * as React from 'react';
import { ArticleHeading2, Image, UIText1, UIText3 } from '@cian/ui-kit';

import * as styles from './PromoDescription.css';
import { IPromoProp } from '../../../../types/promos/promoDetails';

interface IPromoDescriptionProps {
  description?: string | null;
  features: IPromoProp[];
  logo: string;
  name: string;
}

export const PromoDescription: React.FC<IPromoDescriptionProps> = ({ description, features, logo, name }) => {
  return (
    <>
      <div className={styles['header']}>
        <div className={styles['title']}>
          <ArticleHeading2 as="h2">{name}</ArticleHeading2>
        </div>
        <div className={styles['logo']}>
          <Image src={logo} borderRadius="0" objectFit="contain" />
        </div>
      </div>
      {features.length > 0 && (
        <ul className={styles['features-list']}>
          {features.map((feature, idx) => (
            <li key={idx} className={styles['feature-item']}>
              <div className={styles['feature-title']}>
                <UIText3 color="black_60">{feature.title}</UIText3>
              </div>
              <UIText1 display="block">{feature.value}</UIText1>
            </li>
          ))}
        </ul>
      )}
      {description && <p className={styles['description']}>{description}</p>}
    </>
  );
};
